import { App } from 'vue'
import VueResizeText from './VueResizeText'

export default {
  install: (app: App) => {
    app.directive('ResizeText', VueResizeText)
  },
  ResizeText: VueResizeText
}